import {Component, OnInit} from '@angular/core';
import {Message, SelectItem} from 'primeng/primeng';
import {DeviceService} from '../services/device.service';
import {UserService} from '../services/user.service';
import {CommandService} from '../services/command.service';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
    selector: 'app-command-report',
    templateUrl: './command-report.component.html',
    styleUrls: ['./command-report.component.css']
})
export class CommandReportComponent implements OnInit {
    msgs: Message[];
    blockedDocument: Boolean = false;
    dateOptions: SelectItem[];
    dateOption: any;
    startDate: Date;
    endDate: Date;
    idDevice: String;
    disabledInitialDate: boolean;
    disabledFinalDate: boolean;
    devices: SelectItem[];
    maxDays = 35;
    commands: any [];
    cols: any[];
    fileName: String;
    typesCounters: any[];

    constructor(private deviceService: DeviceService, private userService: UserService,
                private commandService: CommandService) {
    }

    ngOnInit() {
        this.dateOptions = [
            {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
            {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
            {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
            {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
        ];
        this.cols = [
            {field: 'scheduled', header: 'FECHA/HORA'},
            {field: 'nickName', header: 'USUARIO'},
            {field: 'idDevice', header: 'ID'},
            {field: 'nameDevice', header: 'NOMBRE'},
            {field: 'typeDescription', header: 'TIPO'},
            {field: 'channel', header: 'CANAL'},
            {field: 'statusDescription', header: 'ESTADO'}
        ];
        this.dateOption = 'T';
        this.changeDate();
        this.loadDevices();
    }

    loadDevices() {
        this.devices = [];
        this.devices.push({label: 'Todos', value: null});
        this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
            const response: any = data;
            response.devices.forEach(item => {
                this.devices.push({label: item.name, value: item.idDevice});
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
    }

    changeDate() {
        this.disabledInitialDate = true;
        this.disabledFinalDate = true;
        const dateTime = new Date();
        if (this.dateOption === 'T') {
            this.startDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
            this.endDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else if (this.dateOption === 'Y') {
            this.startDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 0, 0, 0));
            this.endDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 1, 23, 59, 59));
        } else if (this.dateOption === '7') {
            this.startDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - 6, 0, 0, 0));
            this.endDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
        } else {
            this.disabledInitialDate = false;
            this.disabledFinalDate = false;
        }
    }

    buscar() {
        if (this.diferenciaEntreFechasEnDias(this.startDate, this.endDate) > this.maxDays) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'El rango de fechas no debe exceder los ' + this.maxDays + ' dias'
            }];
            return;
        }
        if (this.startDate >= this.endDate) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'La fecha final debe ser superior a la fecha inicial'
            }];
            return;
        }


        this.fileName = `Reporte_Comandos_${this.idDevice === undefined ? 'Todos' : this.devices.find(device => device.value === this.idDevice).label}_${moment(this.startDate).utc().format('DDMMYYYY')}_${moment(this.endDate).utc().format('DDMMYYYY')}`;

        this.blockedDocument = true;
        this.commands = [];
        this.typesCounters = [];
        this.commandService.findCommand(this.userService.userLoged.idUser, this.idDevice, this.startDate, this.endDate).then(data => {
            const response: any = data;
            this.commands = [...response.commands];
            this.commands.forEach(command => {
                command.statusDescription = command.status === 'E' ? 'EJECUTADO' : 'PENDIENTE';
                command.typeDescription = command.type === 'UNLOCKED' ? 'Desbloqueo de Motor' :
                    command.type === 'LOCKED' ? 'Bloqueo de Motor' : 'Actualizar Posición';
            });
            this.commands.forEach(command => {
                const type = this.typesCounters.find(typeCommand => typeCommand.type === command.type);
                if (type === undefined) {
                    this.typesCounters.push({type: command.type, typeDescription: command.typeDescription, count: 1});
                } else {
                    type.count = type.count + 1;
                }
            });
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
            this.blockedDocument = false;
        });
    }

    diferenciaEntreFechasEnDias(a: Date, b: Date): number {
        return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    exportXLS() {
        let records = [];
        this.commands.forEach(item => {
            let data = {};
            this.cols.forEach(col => {
                data[col.header] = item[col.field];
            });
            records.push(data);
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        XLSX.writeFile(workbook, this.fileName + '.xlsx');
    }

}



// WEBPACK FOOTER //
// ./src/app/command-report/command-report.component.ts